import { apiSlice } from "@/redux/apiSlice";

export const adminOrderApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getOrdersAdmin: build.mutation({
            query: ({ params }) => ({
                url: "/api/admin/order/v1",
                method: "get",
                headers: { token: true },
                params: { ...params },
            }),
        }),

        getOrderDetailAdmin: build.mutation({
            query: (orderId) => ({
                url: `/api/admin/order/v1/${orderId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        postOrderAdmin: build.mutation({
            query: (body) => ({
                url: "/api/admin/order/v1",
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),

        getOrderMatchHistoryAdmin: build.mutation({
            query: ({ orderId, params }) => ({
                url: `/api/admin/order/v1/${orderId}/match_history`,
                method: "get",
                headers: { token: true },
                params: { ...params },
            }),
        }),

        putConfirmOrderAdmin: build.mutation({
            query: (body) => ({
                url: `/api/admin/order/v1/${body.orderId}/confirm`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        putModifyOrderAdmin: build.mutation({
            query: (body) => ({
                url: `/api/admin/order/v1/${body.orderId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 요청 취소
        putRequestCancelAdmin: build.mutation({
            query: ({ orderId }) => ({
                url: `/api/admin/order/v1/${orderId}/request_cancel`,
                method: "put",
                headers: { token: true },
            }),
        }),

        // 배정 변경
        putOrderObtainChangeAdmin: build.mutation({
            query: ({ orderId, body }) => ({
                url: `/api/admin/order/v1/${orderId}/obtain/change`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 배차 취소
        putOrderCancelAdmin: build.mutation({
            query: ({ orderId, content }) => ({
                url: `/api/admin/order/v1/${orderId}/order_cancel`,
                method: "put",
                headers: { token: true },
                data: content,
            }),
        }),

        getOrderChatAdmin: build.mutation({
            query: (orderId) => ({
                url: `/api/admin/order/v1/${orderId}/order_chat`,
                method: "get",
                headers: { token: true },
            }),
        }),

        postOrderChatAdmin: build.mutation({
            query: ({ orderId, content }) => ({
                url: `/api/admin/order/v1/${orderId}/order_chat`,
                method: "post",
                headers: { token: true },
                data: { content },
            }),
        }),

        putOrderConfirmAdmin: build.mutation({
            query: ({ orderId, body }) => ({
                url: `/api/admin/order/v1/${orderId}/admin_confirm`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),
    }),
});

export const {
    useGetOrdersAdminMutation,
    useGetOrderDetailAdminMutation,
    usePostOrderAdminMutation,
    useGetOrderMatchHistoryAdminMutation,
    usePutConfirmOrderAdminMutation,
    usePutModifyOrderAdminMutation,
    usePutRequestCancelAdminMutation,
    usePutOrderObtainChangeAdminMutation,
    usePutOrderCancelAdminMutation,
    useGetOrderChatAdminMutation,
    usePostOrderChatAdminMutation,
    usePutOrderConfirmAdminMutation,
} = adminOrderApi;
